import React, { useState } from 'react';

import { CheckCircleIcon } from '@vlabs/icons';
import { usePatchVmsVendorSource } from '@vlabs/api/point-api/client.ts';
import { Control } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import styles from './vmsListTable.module.sass';

export function VmsInputCell({ row }) {
  const [currentRow, setCurrentRow] = useState(row);
  const { t } = useTranslation();
  const updateVmsSource = usePatchVmsVendorSource();

  const changeLunaName = (value) => {
    setCurrentRow({ ...currentRow, luna_name: value });
  };

  const handleUpdate = async () => {
    updateVmsSource.mutateAsync({
      vendor: currentRow.vendor,
      vendorUuid: currentRow.vendor_uuid,
      data: {
        luna_name: currentRow.luna_name,
      },
    }, {
      onSuccess: () => {
        toast.success(t('vms:table.columns.luna_name.onSaveSuccess'));
      },
    });
  };

  return (
    <div className={styles.lunaNameContainer}>
      <Control.Input
        onChange={(e) => changeLunaName(e.target.value)}
        onKeyUp={(e) => {
          if (e.key === 'Enter') handleUpdate();
        }}
        value={currentRow?.luna_name ?? ''}
      />
      <Control.IconButton
        icon={<CheckCircleIcon />}
        kind="positive"
        onClick={handleUpdate}
        variant="dimmed"
      />
    </div>
  );
}
